import { useState } from "react";

import { useEditCategoryMutation } from "@modules/categorys/services/mutations";
import { ActiveCategorySwitchProps } from "./types";

export function useActiveCategorySwitch({ id, value }: ActiveCategorySwitchProps) {
  const [isActive, setIsActive] = useState(value);

  const { mutateAsync, isPending } = useEditCategoryMutation();

  const toggle = async () => {
    await mutateAsync({
      id,
      data: { active: !isActive }
    });

    setIsActive((prev) => !prev);
  }

  return { isActive, isPending, toggle };
}
